import { FC } from "react";
import { useTranslation } from "react-i18next";
import { HiTrash } from "react-icons/hi";
import { DialogForm } from "../DialogForm/DialogForm";

export interface CatalogDeleteConfirmDialogProps {
  /** Full confirmation title (e.g. "Delete vehicle ABC123?"). */
  title: string;
  show: boolean;
  onToggle: () => void;
  onConfirm: () => void;
}

/**
 * Thin wrapper over DialogForm reproducing the delete-confirmation dialog used
 * by the Vehicles and Products inventory pages.
 */
export const CatalogDeleteConfirmDialog: FC<CatalogDeleteConfirmDialogProps> = ({
  title,
  show,
  onToggle,
  onConfirm,
}) => {
  const { t } = useTranslation(["common"]);

  return (
    <DialogForm
      title={title}
      show={show}
      toggleModal={onToggle}
      showHeader={false}
      buttonConfirmColor="failure"
      dismissible
      confirmButton={onConfirm}
      buttonConfirmText={t("common:confirm")}
      buttonConfirmPrependIcon={<HiTrash className="mr-2 h-4 w-4" />}
      buttonCloseText={t("common:close")}
    />
  );
};
